export default "__VITE_ASSET__05c38586__"